


























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FileEntryModel } from "../models/fileEntry";

@Component
export default class FileFilter extends Vue {
  @Prop({ required: true, type: Array }) public value!: FileEntryModel[];
  @Prop({ required: true, type: Array }) public files!: FileEntryModel[];

  private search = "";
  private selectedCategories: string[] = [];

  get categories(): string[] {
    return this.files.map((f: FileEntryModel) => f.category).sort();
  }

  @Watch("files", { immediate: true })
  private onFileWatch(): void {
    this.emitFilteredList();
  }

  private emitFilteredList(): void {
    let filtered = this.files;
    if (this.search !== "") {
      filtered = this.files.filter((f: FileEntryModel) =>
        f.description.toLowerCase().includes(this.search.toLowerCase())
      );
    }
    if (this.selectedCategories.length > 0) {
      filtered = this.files.filter((f: FileEntryModel) =>
        this.selectedCategories.includes(f.category)
      );
    }
    this.$emit("input", filtered);
  }

  private t(key: string): string {
    return this.$t("houseprojects.tables.files." + key).toString();
  }
}
